import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class MunicipioService extends BaseService {
  constructor() {
    super(ConfigApi.municipioURL);
    this.filter = new Filter();
  }

  getFilter() {
    return this.filter;
  }

  setFilter(filter) {
    this.filter = filter;
  }
}

class Filter {
  constructor() {
    this.nome = '';
    this.uf = '';
    this.limit = 0;
    this.page = 0;
  }
}
export default new MunicipioService();
